export const defaultProfilePicture = (name: any) => {
  return `https://ui-avatars.com/api/?name=${name}`;
};
